import { PortalRequest as request } from "@/utils/request";
// 动态类型
export const getNewsType = () => {
  return request({
    url: "/news-type/list-all",
    method: "get",
  });
};
// 动态列表
export const getNewsList = (params, data) => {
  return request({
    url: "/news/list-public",
    method: "post",
    params,
    data,
  });
};
// 动态详情
export const getNewsDetail = (id) => {
  return request({
    url: `/news/${id}/info`,
    method: "get",
  });
};
// 动态banner
export const getAdBanner = () => {
  return request({
    url: `/ad/news/banner/list-all`,
    method: "get",
  });
};
//
export const getPublicityAdBanner = () => {
  return request({
    url: `/ad/homepage/publicity/list-all`,
    method: "get",
  });
};
